import Vue from 'vue';
import IconSvg from '@/components/icon/icon-svg.vue';

Vue.component('icon-svg', IconSvg);

const requireAll = (requireContent) => { requireContent.keys().map(requireContent); };
const req = require.context('./svg', false, /\.svg$/);
requireAll(req);
